import * as React from "react";
const SustainabilityCertificationSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      fill="#040919"
      fillOpacity={0.02}
      rx={24}
    />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#040919"
      strokeOpacity={0.03}
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#040919"
      d="M28 28.875a.875.875 0 0 1-.875.875h-5.25a.875.875 0 1 1 0-1.75h5.25a.875.875 0 0 1 .875.875Zm-.875-4.375h-5.25a.875.875 0 1 0 0 1.75h5.25a.875.875 0 1 0 0-1.75Zm12.25 7.16v6.84a.874.874 0 0 1-1.313.766l-2.624-1.503-2.626 1.503A.875.875 0 0 1 31.5 38.5v-2.625H18.375a1.75 1.75 0 0 1-1.75-1.75v-14a1.75 1.75 0 0 1 1.75-1.75h19.25a1.75 1.75 0 0 1 1.75 1.75v3.34a5.675 5.675 0 0 1 0 8.196ZM31.5 34.126v-2.464a5.688 5.688 0 0 1 6.125-9.349v-2.187h-19.25v14H31.5Zm6.125-1.313a5.675 5.675 0 0 1-4.375 0v4.18L35 35.992a.876.876 0 0 1 .868 0l1.75 1.002.007-4.18Zm1.75-5.25a3.937 3.937 0 1 0-7.875 0 3.937 3.937 0 0 0 7.875 0Z"
    />
  </svg>
);
export default SustainabilityCertificationSVG;
